import './flash.css'
import './static/cross.svg'
